// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import PlainNav, { NavItem } from 'app/common/ui/PlainNav';


type Props = {
  className?: string
}

const FoodCategorySwitcher = ({ className }: Props) => {
  const { t } = useTranslation('cafeteria');

  return (
    <PlainNav className={className}>
      <NavItem active>
        {t('order_request_sales_put_on_food_category_complex', 'Комплекты')}
      </NavItem>
    </PlainNav>
  );
};

export default FoodCategorySwitcher;
